module.exports = __webpack_public_path__ + "static/01-a34c4d2a997a0cbe4e4ad32f02bb2da1.jpg";